/* eslint-disable */

import React from 'react'
import { string } from 'prop-types'

import ChooseAvatarOption from '../../elements/ChooseAvatarOption'

import { AvatarContainer, AvatarList, Container, Content, ListItem, Title } from './styles'

const { title } = require('./data.json')

const avatarList = [
  require('../../../static/avatars/avatar-1.png'),
  require('../../../static/avatars/avatar-2.png'),
  require('../../../static/avatars/avatar-3.png'),
  require('../../../static/avatars/avatar-4.png'),
  require('../../../static/avatars/avatar-5.png'),
  require('../../../static/avatars/avatar-6.png'),
  require('../../../static/avatars/avatar-7.png'),
  require('../../../static/avatars/avatar-8.png')
]

function ChooseAvatar(props) {
  const { label } = props
  return null
  // return (
  //   <Container>
  //     <Content>
  //       <Title>{title}</Title>
  //       <AvatarContainer>
  //         <AvatarList>
  //           {avatarList.map((avatar, i) => (
  //             <ListItem key={avatar}>
  //               <ChooseAvatarOption
  //                 key={avatar}
  //                 value={i}
  //                 onChange={props.onChange}
  //                 name="avatar"
  //                 avatarUrl={avatar}
  //               />
  //             </ListItem>
  //           ))}
  //         </AvatarList>
  //       </AvatarContainer>
  //     </Content>
  //   </Container>
  // )
}

ChooseAvatar.defaultProps = {
  label: null
}

ChooseAvatar.propTypes = {
  label: string
}

export default ChooseAvatar
